import Vue from 'vue'
import TurbolinksAdapter from 'vue-turbolinks'
import {Chrome} from 'vue-color'
import {clickOutside} from '../directives'

const defaultHex = '#000000'

document.addEventListener('turbolinks:load', () => {
  const el = document.querySelector('.vue-color-picker')
  if (el) {
    new Vue({
      el,
      mixins: [TurbolinksAdapter],
      components: {
        'color-picker': Chrome
      },
      data: {
        colors: {hex: '', a: 1},
        visible: false
      },
      methods: {
        clickOutside (event) {
          this.visible = false
        },
        updateValue (values) {
          const colors = {
            ...values,
            a: 1
          }
          this.colors = colors
        }
      },
      mounted () {
        const {value} = this.$refs.colorField.dataset
        if (value && value !== '') {
          this.colors = {
            hex: this.$refs.colorField.dataset.value,
            a: 1
          }
        }
      },
      directive: {
        clickOutside
      }
    })
  }
})


// WEBPACK FOOTER //
// ./app/javascript/packs/components/color_picker.js